import simulationOptions from "./simulationOptions";
const defaultSpans = getDefaultSpans();

const values = {
	// general
	type: "ROOF",
	profileType: "OMEGA",
	supportWidth: "BETWEEN_135_AND_200",
	location: "PORTUGAL",
	angle: 5,
	profileSpacing: 2, // validation: > 0
	profileOrientation: "HORIZONTAL",
	profileFormat: "MAJOR_AXIS_BENDING_REGULAR",

	// spans
	spans: defaultSpans,

	//loads
	loads: {
		permanent: {
			distributed: getDefaultLoadsPermanentDistributed({ spans: defaultSpans }),
			point: [
				{
					targetSpans: [], //spanSelectorId[]
					loads: [0, 0, 0, 0], //[v1,v2,v3,v4]
				},
				// ...
			],
		},

		live: {
			distributed: getDefaultLoadsLiveDistributed({ spans: defaultSpans }),
			point: [
				{
					targetSpans: [], //spanSelectorId[]
					loads: [0, 0, 0, 0], //[v1,v2,v3,v4]
				},
				// ...
			],
		},
	},

	wind: getDefaultsWind(),

	snow: getDefaultsSnow({ spans: getDefaultSpans() }),

	axialLoads: getDefaultAxialLoads(),

	locks: getDefaultLocks({ spans: getDefaultSpans() }),

	deformation: 200,

	combination: "CHARACTERISTIC",

	claddingProperties: getDefaultCladdingProperties(),
};

const simulationDefaults = {
	id: "new",
	name: "Untitled",
	project: "Untitled Project",
	chosenSolution: null,
	calculationStatus: "NEW",
	steelGrades: simulationOptions.steel.options.map(({ id }) => id),
	creationDate: null,
	lastUpdateDate: null,
	values,
	result: null,
};

export default simulationDefaults;

export function getDefaultSpans() {
	return {
		main: [{ size: 5 }], // { size, id }[]  ( id is used just for vue rendering purposes )
		console: [{ size: 0.25 }, { size: 0.25 }], // { size }[]
		useConsole: true,
	};
}

export function getDefaultLoadsPermanentDistributed({ spans }) {
	return {
		cfgMode: {
			isMinMax: false,
			isSpanBySpan: false,
		},
		main: Array(spans.main.length).fill({ min: 1, max: 1 }),
		console: Array(spans.console.length).fill({ min: 1, max: 1 }),
	};
}

export function getDefaultLoadsLiveDistributed({ spans }) {
	return {
		cfgMode: {
			deltaCfgOption: "category_h",
			isSpanBySpan: false,
		},
		deltas: [0, 0, 0],
		main: Array(spans.main.length).fill(1),
		console: Array(spans.console.length).fill(1),
	};
}

export function getDefaultsWind() {
	return {
		deltas: [0.6, 0.2, 0],

		cfgMode: {
			deltaCfgOption: "en1991-1-4",
			isBandByBand: false,
		},

		general: {
			pressure: {
				w: [0, 0, 0],
				l: [0, 0, 0],
			},
			suction: {
				w: [0, 0, 0],
				l: [0, 0, 0],
			},
		},

		local: {
			use: false,
			pressure: {
				w: [0, 0, 0],
				l: [0, 0, 0],
			},
			suction: {
				w: [0, 0, 0],
				l: [0, 0, 0],
			},
		},
	};
}

export function getDefaultsSnow({ spans }) {
	return {
		cfgMode: {
			deltaCfgOption: "h<=1000m",
		},

		deltas: [0.5, 0.2, 0],

		general: {
			cfgMode: {
				isSpanBySpan: false,
			},
			main: Array(spans.main.length).fill(1),
			console: Array(spans.console.length).fill(1),
		},

		exceptional: {
			use: false,
			cfgMode: {
				isSpanBySpan: false,
			},
			main: Array(spans.main.length).fill(1),
			console: Array(spans.console.length).fill(1),
		},

		snowAccumulation: {
			use: false,
			s: [0, 0, 0],
			l: [0, 0, 0],
		},
	};
}

export function getDefaultLocks({ spans }) {
	return {
		use: false,
		upperFibre: {
			type: 0,
			lateralLocks: {
				cfgMode: {
					isSpanBySpan: false,
				},
				main: Array(spans.main.length).fill(0),
				console: Array(spans.console.length).fill(0),
			},
		},
		lowerFibre: {
			use: false,
			lateralLocks: {
				cfgMode: {
					isSpanBySpan: false,
				},
				main: Array(spans.main.length).fill(0),
				console: Array(spans.console.length).fill(0),
			},
		},
	};
}

export function getDefaultCladdingProperties() {
	return {
		use: false,
		coveringInertia: 0,
		fixationsPerMeter: 0,
	};
}

export function getDefaultAxialLoads() {
	return {
		use: false,
		type: "DESIGN",
		value: 0,
		direction: "TRACTION",
	};
}
